/**
 * Rate Connect guided tour step configuration
 * Defines steps for the onboarding/help tour
 * Used by tour component to guide users through features
 */

import type { LocationQueryRaw } from "vue-router"

/** Tooltip position options */
export type TooltipPosition = 'top' | 'bottom' | 'left' | 'right'

/** Route configuration for tour step */
export interface TourStepRoute {
  name: string
query?: LocationQueryRaw
}

/** Tour step configuration */
export interface TourStep {
  badge: string
  title: string
  description: string
  route: TourStepRoute
  selector?: string
  selectors?: readonly string[]
  tooltipPosition: TooltipPosition
  tooltipCenter?: boolean
  allowScroll?: boolean
  clipAtNav: boolean
}

export const RATE_CONNECT_TOUR_STEPS: readonly TourStep[] = [
  {
    badge: 'rc_tour_campaign_status',
    title: 'rc_tour_campaign_status_header',
    description: 'rc_tour_campaign_status_text',
    route: { name: 'rate-connect-running-performance' },
    selector: '#status-bar-status-card',
    tooltipPosition: 'bottom',
    clipAtNav: true,
  },
  {
    badge: 'rc_tour_connection',
    title: 'rc_tour_connection_header',
    description: 'rc_tour_connection_text',
    route: { name: 'rate-connect-running-performance' },
    selector: '#status-bar-connectivity-provider',
    tooltipPosition: 'bottom',
    clipAtNav: true,
  },
  {
    badge: 'rc_tour_rate_unabailability',
    title: 'rc_tour_rate_unavailability_header',
    description: 'rc_tour_rate_unavailability_text',
    route: { name: 'rate-connect-running-performance' },
    selector: '#status-bar-rate-unavailability',
    tooltipPosition: 'bottom',
    clipAtNav: true,
  },
  {
    badge: 'rc_tour_commission_rate',
    title: 'rc_tour_commission_rate_header',
    description: 'rc_tour_commission_rate_text',
    route: { name: 'rate-connect-running-performance' },
    selector: '#status-bar-commission-rate',
    tooltipPosition: 'bottom',
    clipAtNav: true,
  },
  {
    badge: 'rc_tour_performance',
    title: 'rc_tour_performance_header',
    description: 'rc_tour_performance_text',
    route: { name: 'rate-connect-running-performance' },
    selectors: ['#rate-connect-performance', '#rc-tabs-performance'],
    tooltipCenter: true,
    allowScroll: true,
    tooltipPosition: 'top',
    clipAtNav: true,
  },
  {
    badge: 'rc_tour_booking_details',
    title: 'rc_tour_booking_details_header',
    description: 'rc_tour_booking_details_text',
    route: { name: 'rate-connect-running-booking-details' },
    selectors: ['#rate-connect-performance', '#rc-tabs-booking-details'],
    tooltipCenter: true,
    allowScroll: true,
    tooltipPosition: 'top',
    clipAtNav: true,
  },
  {
    badge: 'rc_tour_filter_export',
    title: 'rc_tour_filter_export_header',
    description: 'rc_tour_filter_export_text',
    route: { name: 'rate-connect-running-booking-details' },
    selector: '#rate-connect-filters',
    tooltipCenter: true,
    tooltipPosition: 'top',
    clipAtNav: true,
  },
  {
    badge: 'rc_tour_invoices',
    title: 'rc_tour_invoices_header',
    description: 'rc_tour_invoices_text',
    route: { name: 'billing-invoices', query: { navigation_open: "true" } },
    selector: '#user-navigation',
    tooltipPosition: 'left',
    clipAtNav: false,
  },
] as const

/** Number of tour steps */
export const TOUR_STEPS_COUNT = RATE_CONNECT_TOUR_STEPS.length

